import type { ReactNode } from "react";
import { hasSiteBuilderBlocks } from "./SiteBuilderContent";
import type {
    ResolvedTemplateDesign,
    SiteBuilderContentJson,
    TemplateLinkComponent,
    TemplateRenderProps,
} from "./types";
import { WebBuilderRegionStyles } from "./WebBuilderRegionStyles";
import { WebSiteBuilderContent } from "./WebSiteBuilderContent";

export function WebGlobalBuilderRegion({
    children,
    design,
    document: documentOverride,
    fallback,
    LinkComponent,
    props,
    region,
}: {
    children?: ReactNode;
    design: ResolvedTemplateDesign;
    document?: SiteBuilderContentJson | null;
    fallback?: ReactNode;
    LinkComponent: TemplateLinkComponent;
    props: TemplateRenderProps;
    region: "footer" | "header";
}) {
    const layout = props.page?.globalLayout ?? props.site?.globalLayout ?? null;
    const document = documentOverride === undefined
        ? layout?.[region] ?? null
        : documentOverride;

    if (!hasSiteBuilderBlocks(document)) {
        return fallback ?? null;
    }

    return (
        <>
            <WebBuilderRegionStyles />
            <div
                data-builder-document-region={region}
                data-web-builder-global-region={region}
                data-web-builder-region={region}
                style={{ display: "contents" }}
            >
                <WebSiteBuilderContent
                    bookingDemoData={props.bookingDemoData}
                    contentJson={document}
                    design={design}
                    editorMode={Boolean(props.editorMode)}
                    headerActions={props.headerActions}
                    leadForm={props.leadForm}
                    leadForms={props.leadForms}
                    LinkComponent={LinkComponent}
                    menus={props.menus}
                    navigationReadOnly={props.navigationReadOnly}
                    page={props.page}
                    pages={props.pages}
                    readOnly={props.readOnly}
                    site={props.site}
                />
                {children}
            </div>
        </>
    );
}
